import { config } from '../config/index.js';

import prod from './configureStore.prod.js';
import dev from './configureStore.dev.js';

export default function configureStore() {
    if (config.env === 'production') return prod();
    return dev();
}
